<div class="allfootcont">
  <div class="footcont">
    <div class="contenedor centro">
      <div class="tabcell">
        <div class="autorow pull-left full-c mob-text mob-width">
          <img width="100%" class="footlogo" src="../../../../assets/images/footlogo.png">Todos los derechos reservados, Claro 2021
        </div>
        <div class="autorow pull-right full-c mob-text">
          <a routerLink="/politics/1" class="linkdefs" >Legal y Regulatorio</a>
        </div>
      </div>
    </div>
  </div>
</div>
      